import { withRBAC } from "../rbac";
import { QuickVendorCreateModal } from "./QuickVendorCreateModal";
import { VendorApprovalQueue } from "./VendorApprovalQueue";
import { VendorCreate } from "./VendorCreate";
import { VendorEdit } from "./VendorEdit";
import { VendorInviteButton } from "./VendorInviteButton";
import { VendorList } from "./VendorList";
import { VendorOnboardingPage } from "./VendorOnboardingPage";
import { VendorShow } from "./VendorShow";

export const vendors = {
  list: withRBAC(VendorList, "view_all_data"),
  show: withRBAC(VendorShow, "view_all_data"),
  create: withRBAC(VendorCreate, "manage_documents"),
  edit: withRBAC(VendorEdit, "manage_documents"),
  recordRepresentation: "name",
  VendorApprovalQueue: withRBAC(VendorApprovalQueue, "view_all_data"),
};

export { VendorOnboardingPage, VendorInviteButton, QuickVendorCreateModal, VendorApprovalQueue };
